import renderToastifyMessage
  from "../../../../Visol.NewsletterSubscriptionManagement/Resources/Public/JavaScripts/ToastifyMessageRenderer";
import { Loader } from '@googlemaps/js-api-loader';

$(function () {
  // Initialize on page (re-)load
  document.addEventListener('Neos.PageLoaded', function(event) {
    AblChMaps.initializeResidentialAreaMap();
  }, false);

  const googleMapsConsentElements = document.querySelectorAll('.google-maps-privacy');

  for (let googleMapsConsent of googleMapsConsentElements) {
    if (sessionStorage.getItem("googleMapsConsent")) {
      googleMapsConsent.remove();
      AblChMaps.initializeResidentialAreaMap();
    } else {
      const consentButton = googleMapsConsent.querySelector('button');
      consentButton.addEventListener('click', (event) => {
        const emptyMapElement = event.target.parentNode.nextElementSibling;

        if (emptyMapElement && emptyMapElement.classList.contains('area__map__empty')) {

          sessionStorage.setItem("googleMapsConsent", "true");
          googleMapsConsent.remove();
          AblChMaps.initializeResidentialAreaMap();
        }
      })
    }
  }
});

var AblChMaps = {

    initializeResidentialAreaMap: function () {
        const residentialAreaMaps = document.querySelectorAll('.area__map__empty');

        if (sessionStorage.getItem("googleMapsConsent") && residentialAreaMaps.length) {
            for (let residentialAreaMap of residentialAreaMaps) {
              residentialAreaMap.classList.remove('area__map__empty');
              residentialAreaMap.classList.add('area__map');

              const parentElement = residentialAreaMap.parentNode;

              const loader = new Loader({
                apiKey: "AIzaSyCuioUWDETqArcmlrHSaQ1ssUSgNEaGLF8",
                version: "weekly",
                libraries: ["places"]
              });

              const latitude = residentialAreaMap.getAttribute('data-latitude');
              const longitude = residentialAreaMap.getAttribute('data-longitude');
              const latlong = {
                lat: Number(latitude),
                lng: Number(longitude)
              };

              const mapType = residentialAreaMap.getAttribute('data-map-type') ? residentialAreaMap.getAttribute('data-map-type') : 'hybrid';

              const mapOptions = {
                center: latlong,
                zoom: parentElement.classList.contains('visol-ablch-content-googlemap') ? 15 : 18,
                mapTypeId: mapType
              };

              loader.loadCallback(e => {
                if (e) {
                  console.log(e);
                } else {
                  const map = new google.maps.Map(document.querySelector('.area__map'), mapOptions);
                  const title = residentialAreaMap.getAttribute('data-title');

                  const marker = new google.maps.Marker({
                    map: map,
                    position: latlong,
                    title: title
                  });

                  const content = '<strong>' + title + '</strong>';

                  const infoWindow = new google.maps.InfoWindow({
                    content: content
                  });

                  google.maps.event.addListener(marker, 'click', (function (infoWindow, marker, map) {
                    return function () {
                      infoWindow.open(map, marker);
                    }
                  })(infoWindow, marker, map));
                }
              });
            }
        }
    }
}
